<br />
<div class="container text-center">
    <img style="width:200px;" src="../../../assets/images/error/404.png" />
    <h1 class="display-1 pb-3">Oops!</h1>
    <p>Error code: 404</p>
    <p class="lead">We can't seem to find the page you were looking for.</p>
    <p class="lead">Pick and choo-choose some of the popular features listed below.</p>
</div>
<app-main-footer></app-main-footer>